export default __webpack_public_path__ + "static/media/DevIcon.3909c30c.png";